// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"6ce9257c","126":"9d5a9507","171":"850f5ea2","383":"3e926c64","466":"cadb81a1","491":"20c52149","507":"3918875d","533":"98fb814c","576":"87fef2aa","759":"7a05c8e4","780":"db6364c2"}[chunkId] + ".chunk.js";
};